import { render, staticRenderFns } from "./NxDepartments.vue?vue&type=template&id=0683207f&scoped=true"
import script from "./NxDepartments.vue?vue&type=script&lang=js"
export * from "./NxDepartments.vue?vue&type=script&lang=js"
import style0 from "./NxDepartments.vue?vue&type=style&index=0&id=0683207f&prod&scoped=true&lang=css"
import style1 from "./NxDepartments.vue?vue&type=style&index=1&id=0683207f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0683207f",
  null
  
)

export default component.exports